import React from "react";

interface SpinnerProps {
  size?: number;
}

const Spinner = ({ size = 60 }: SpinnerProps) => {
  const borderWidth = Math.max(3, Math.round(size / 12));

  return (
    <div
      role="status"
      aria-label="로딩중"
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        border: `${borderWidth}px solid #e5e5e5`,
        borderTopColor: "#263725",
        animation: "spinner-rotate 0.8s linear infinite",
      }}
    />
  );
};

export default Spinner;
